import React from 'react';
import '../App.css';


class Header extends React.Component {

    headerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };

    imageStyle = {
        border: "5px solid black",
        width: "98%", 
        height: "20%",
        marginTop:"20px",
        marginBottom: "10px"
    }

    title = {
        fontSize: '3vw',
    }
    
    render() {
        return (
        <div style={this.headerStyle}>
            <h1 style={this.title}>BEN SANDER</h1>
        </div>
        );
    }
}

export default Header;